import React from 'react';
import PropTypes from 'prop-types';

import ListHead from './ListHead';
import ListRow from './ListRow';

// Styles
import styles from './styles/ListView.scss';

function ListView(props) {
    const {
        items,
        addNote,
        currency,
        isPublic,
        selecting,
        showDealerBranding,
        showProjects,
        user,
        viewer,
    } = props;
    return (
        <div className={styles.table}>
            <ListHead showDealerBranding={showDealerBranding} showProjects={showProjects} />
            {items.map(item => (
                <ListRow
                    key={item.firstPhotoWebPath}
                    addNote={addNote}
                    currency={currency}
                    isPublic={isPublic}
                    item={item}
                    noteContent={item.note}
                    portfolioItemId={item.portfolioItemId}
                    projects={item.tilesProjects}
                    selecting={selecting}
                    showDealerBranding={showDealerBranding}
                    showProjects={showProjects}
                    totalItems={items.length}
                    user={user}
                    viewer={viewer}
                />
            ))}
        </div>
    );
}

ListView.propTypes = {
    addNote: PropTypes.func,
    currency: PropTypes.string,
    items: PropTypes.array,
    projects: PropTypes.array,
    selecting: PropTypes.bool,
    showProjects: PropTypes.bool,
    isPublic: PropTypes.bool,
    showDealerBranding: PropTypes.bool,
    user: PropTypes.object,
    viewer: PropTypes.object,
};

export default ListView;
